import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ContentSection, Heading } from "@cinch-labs/design-system";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { renderWithResolver } from "@cinch-nx/landing-ui-shared";
import { Table } from "@cinch-nx/landing-ui-shared";
import { StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { Head } from "@cinch-nx/landing-ui-shared";
import { Wrapper } from "@cinch-nx/shared-ui";
import { storyblokComponents } from "./data/storyblok-renderer-map";
import styles from "./landing-feature-policy-pages.module.css";
var shouldRenderTable = function(table) {
    var ref, ref1, ref2;
    return (table === null || table === void 0 ? void 0 : table.fieldtype) === "table" && (table === null || table === void 0 ? void 0 : table.tbody.length) > 0 && ((ref1 = (ref = table.tbody) === null || ref === void 0 ? void 0 : ref[0].body) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.value) !== " ";
};
export function PolicyPageFeature(param) {
    var story = param.story, preview = param.preview;
    var ref, ref1, ref2;
    var typedStory = story;
    var content = useStoryblokState({
        story: typedStory,
        enableBridge: preview
    }).content;
    var typedContent = content;
    var SEO = typedContent === null || typedContent === void 0 ? void 0 : (ref = typedContent["SEO"]) === null || ref === void 0 ? void 0 : ref[0];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, _object_spread_props(_object_spread({}, SEO), {
                fallbackTitle: (story === null || story === void 0 ? void 0 : story.slug) ? story === null || story === void 0 ? void 0 : story.slug : "Cinch Used Cars Article",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with free home delivery or from an approved dealer."
            })),
            /*#__PURE__*/ _jsx(Wrapper, {
                className: {
                    inner: styles.container
                },
                "data-testid": "feature-policy-page-wrapper",
                children: typedContent && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Heading, {
                            element: "h1",
                            className: styles.title,
                            fontSize: "h1",
                            children: typedContent.title
                        }),
                        /*#__PURE__*/ _jsx(ContentSection, {
                            classNames: {
                                body: "storyblokRichTextBody"
                            },
                            children: renderWithResolver(typedContent.body, true)
                        }),
                        typedContent.table && shouldRenderTable(typedContent.table) && /*#__PURE__*/ _jsx(Table, _object_spread({}, typedContent.table)),
                        typedContent.widestRangeClaimTable && shouldRenderTable((ref1 = typedContent.widestRangeClaimTable) === null || ref1 === void 0 ? void 0 : ref1.table) && /*#__PURE__*/ _jsx(Table, _object_spread({}, (ref2 = typedContent.widestRangeClaimTable) === null || ref2 === void 0 ? void 0 : ref2.table)),
                        typedContent.clauses && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: typedContent.clauses,
                            components: storyblokComponents
                        }),
                        typedContent.cookiePolicy && /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: typedContent.cookiePolicy,
                            components: storyblokComponents
                        })
                    ]
                })
            })
        ]
    });
}
export default PolicyPageFeature;
